import type { FC } from "react";

import { MDSButton, MDSButtonVariant, MDSText, MDSTextColor, MDSTextVariant } from "@/mds";

import { ActionsRow, ActionsWrapper } from "./shared";

interface InviteReadyPendingViewProps {
  onAccept: () => void;
  isAccepting: boolean;
  acceptError: string | null;
}

export const InviteReadyPendingView: FC<InviteReadyPendingViewProps> = ({
  onAccept,
  isAccepting,
  acceptError,
}) => (
  <ActionsWrapper>
    <ActionsRow>
      <MDSButton variant={MDSButtonVariant.Contrast} onPress={onAccept} isLoading={isAccepting}>
        Accept invite
      </MDSButton>
    </ActionsRow>
    {acceptError ? (
      <MDSText as="p" variant={MDSTextVariant.TextXs} color={MDSTextColor.Danger}>
        {acceptError}
      </MDSText>
    ) : null}
  </ActionsWrapper>
);
